import _ from 'lodash';
import { parse } from 'querystring';
import { getToken } from './token';

export const getPageQuery = () => {
  const { href } = window.location;
  const qsIndex = href.indexOf('?');
  const sharpIndex = href.indexOf('#');

  if (qsIndex !== -1) {
    if (qsIndex > sharpIndex) {
      return parse(href.split('?')[1]);
    }

    return parse(href.slice(qsIndex + 1, sharpIndex));
  }

  return {};
};
export async function wait(time: number) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve('');
    }, time);
  });
}

export const replaceGoto = () => {
  let { redirect } = getPageQuery() as { redirect: string };
  if (redirect) {
    const urlParams = new URL(window.location.href);
    const redirectUrlParams = new URL(redirect);
    if (urlParams.host !== redirectUrlParams.host) {
      const token = getToken();
      if (_.isEmpty(redirectUrlParams.search)) {
        redirect += `?accessToken=${token}`;
      } else {
        redirect += `&accessToken=${token}`;
      }
    }
    window.location.href = redirect;
  } else {
    window.location.href = '/';
  }
};

export function toHump(name: string) {
  return name.replace(/_(\w)/g, (all, letter) => {
    return letter.toUpperCase();
  });
}

export function captureName(name: string) {
  return name.charAt(0).toUpperCase() + name.slice(1);
}

